module.exports = __webpack_public_path__ + "static/media/IDBI.db125c77.svg";